import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  trackLandingPageType: 'lead',
  emailSuggestionEnabled: true,
  redirectOnSuccessUrl: '/de/booking/{hash}/',
  featuresFlags: {
    postalCode: false,
    honeyPotEmail: false,
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
    dropOffEmailDelayInMinutes: 20,
  },
  abExperiment: initialPropsExperimentConfig.carleadCreation,
  minimumMileage: true,
  pageName: 'sellCar',
  hreflangLinks: [
    { locale: 'de-DE', path: '/de/auto-verkaufen/' },
    { locale: 'de-AT', path: '/at/auto-verkaufen/' },
    { locale: 'sv-SE', path: '/se/salja-bil/' },
    { locale: 'fr-BE', path: '/fr-be/vendre-sa-voiture/' },
    { locale: 'fr-FR', path: '/fr/vendre-sa-voiture/' },
    { locale: 'it-IT', path: '/it/vendere-auto/' },
    { locale: 'es-ES', path: '/es/vendo-coche/' },
  ],
};
